import { bootstrapAdminCsrfToken, resolveCsrfHeaderForMethod } from '../../../lib/api/csrfToken'
import { API_BASE } from '../constants'
import { isCsrfFailure } from './errors'
import { readResponsePayload } from './payloads'
import { requestSetupApi } from './request'

export const buildSetupJsonPostInit = (payload: unknown): RequestInit => ({
  method: 'POST',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    ...resolveCsrfHeaderForMethod('POST'),
  },
  body: JSON.stringify(payload),
})

export const executeCsrfProtectedSetupPost = async ({
  path,
  payload,
  fallbackError,
}: {
  path: string
  payload: unknown
  fallbackError: string
}) => {
  await bootstrapAdminCsrfToken(API_BASE)

  const execute = async () => {
    const response = await requestSetupApi({
      path,
      fallbackError,
      init: buildSetupJsonPostInit(payload),
    })
    const parsed = await readResponsePayload(response)
    return { response, ...parsed }
  }

  let outcome = await execute()
  if (!outcome.response.ok && isCsrfFailure(outcome.response, outcome.data, outcome.raw)) {
    await bootstrapAdminCsrfToken(API_BASE)
    outcome = await execute()
  }

  return outcome
}
